export interface ThesisData {
  id: number | null
  tid: string
  title: string
  parent_id: number | null
  sort_num: number
}

export interface ThesisInterface {
  id(): number | null

  anchor(): string

  title(): string

  hasTheses(): boolean

  theses(): Array<ThesisInterface>

  addThesis(thesis: ThesisInterface): void

  sortNum(): number
}

export default class Thesis implements ThesisInterface {
  private data: ThesisData
  private readonly _theses: Array<ThesisInterface>

  public constructor(data: ThesisData) {
    this.data = data
    this._theses = []
  }

  id(): number | null {
    return this.data.id
  }

  anchor(): string {
    return this.data.tid
  }

  title(): string {
    return this.data.title
  }

  hasTheses(): boolean {
    return this._theses.length > 0
  }

  theses(): Array<ThesisInterface> {
    return this._theses
  }

  addThesis(thesis: ThesisInterface): void {
    this._theses.push(thesis)
  }

  sortNum(): number {
    return this.data.sort_num
  }
}
